import { InventoryRemainingModalData, InventoryResource } from '../../types/InvetoryResource';
import { InventoryActions, InventoryActionType } from './InventoryActions';

export type InventoryState = {
  inventoryData: InventoryResource[];
  lastUpdated: string | null;
  loading: boolean;
  error: boolean;
  remainingModal: boolean;
  remainingBulkInventory: InventoryRemainingModalData;
};

export const initialInventoryState: InventoryState = {
  inventoryData: [],
  lastUpdated: null,
  loading: false,
  error: false,
  remainingModal: false,
  remainingBulkInventory: {
    done: 0,
    total: 0,
    remaining: 0,
    isBulkSelect: false,
    closedDealIds: [],
    remainingLeaseDeals: 0,
    remainingCashDeals: 0,
    remainingFinanceDeals: 0,
  },
};

export const inventoryReducer = (
  state: InventoryState = initialInventoryState,
  action: InventoryActions,
): InventoryState => {
  switch (action.type) {
    case InventoryActionType.INVENTORY_LOADING:
      return {
        ...state,
        inventoryData: [],
        lastUpdated: null,
        loading: true,
        error: false,
      };
    case InventoryActionType.INVENTORY_LOADED:
      return {
        ...state,
        inventoryData: action.payload.inventory,
        lastUpdated: formatDate(action.payload.lastUpdated),
        loading: false,
        error: false,
      };
    case InventoryActionType.INVENTORY_ERROR:
      return {
        ...state,
        inventoryData: [],
        lastUpdated: null,
        loading: false,
        error: true,
      };
    case InventoryActionType.INVENTORY_REMOVE:
      return {
        ...state,
        inventoryData: [],
        lastUpdated: null,
        loading: false,
        error: false,
      };
    case InventoryActionType.INVENTORY_REMAINING_MODAL:
      return {
        ...state,
        remainingModal: action.payload,
      };
    case InventoryActionType.INVENTORY_REMAINING_MODAL_DATA:
      return {
        ...state,
        remainingBulkInventory: action.payload,
      };
    default:
      return state;
  }
};

function getOrdinalSuffix(date: Date) {
  const day = date.getDate();
  if (day > 3 && day < 21) {
    return 'th';
  }
  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
}

function formatDate(dateString: string) {
  const date = new Date(dateString);
  const day = date.getDate();
  const formattedDate = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
  return `${formattedDate} ${day}${getOrdinalSuffix(date)}`;
}
